<template>
  <div>
    <b-card no-header>
      <form>
        <!-- <b-form-group
          label-for="isValidado">
          <b-form-checkbox 
              id="isValidado"
              v-model="isValidado"
              value= true
              unchecked-value= false
              :state="validacionValida">
              ¿Validaste todos la información: mecánica, ortografía, QR, fechas de vigencia, números de WhatsApp, marcas participantes, medidas, etc. de todas las piezas para que se envíe el original a producción?
          </b-form-checkbox>
        </b-form-group> -->

        <b-form-group
          description="Mecánica, ortografía, QR, fechas de vigencia, números de WhatsApp, marcas participantes, medidas, etc.">
          <b-form-checkbox 
              id="isValidado"
              v-model="isValidado"
              :value="Boolean(true)"
              :unchecked-value="Boolean(false)">
              ¿Validaste la información de todas las piezas para que diseño arme el original?
              ¿Validaste que el archivo cumpla con los requerimientos técnicos solicitados por el proveedor y el contenido?
          </b-form-checkbox>
        </b-form-group>

        <br>

        <b-form-group
          description="Especificaciones para armado del original (contemplar lo que solicita cada proveedor)">
          <b-form-textarea
            id="especificaciones"
            v-model="$v.especificaciones.$model" 
            rows="5"
            max-rows="5"
            :state="especificacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="especificacionesFeedback">
            {{ especificacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" :disabled="!isValidado"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'BriefValidacionInformacion',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    especificacionesMuestra: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isValidado: false,
      especificaciones: '',

      noValidar: true,
      especificacionesValidas: null,
      especificacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.especificaciones = this.especificacionesMuestra;
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'especificaciones' || validarTodos) {
        if (this.$v.especificaciones.$error) {
          this.especificacionesValidas = false;
          if (!this.$v.especificaciones.maxLength) {
            this.especificacionesInvalidasMsj = 'Las especificaciones para la muestra solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.especificacionesValidas = null;
          this.especificacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            especificaciones: this.especificaciones.trim(),
          }
          this.$emit('registrarValidacion', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarValidacion')
    },
  },
  validations: {
    especificaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
